import { useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";
import { DARK } from "./seedance/constants";

// Umbral tras el cual el gate deja de ser un "Loading…" mudo y ofrece salida.
// El camino feliz resuelve auth en <1s (medido), así que este aviso solo
// aparece cuando algo va MAL en el cliente (socket colgado, red intermitente,
// service worker viejo). Antes, ese caso dejaba pantalla negra indefinida sin
// pista ni escape; ahora el usuario ve qué pasa y puede recargar.
const SLOW_AUTH_HINT_MS = 6000;

export default function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();
  const [slow, setSlow] = useState(false);

  useEffect(() => {
    if (!loading) { setSlow(false); return undefined; }
    const t = setTimeout(() => setSlow(true), SLOW_AUTH_HINT_MS);
    return () => clearTimeout(t);
  }, [loading]);

  if (loading) {
    return (
      <div style={{
        minHeight: "100vh", background: DARK.bg, color: DARK.textDim,
        display: "flex", flexDirection: "column", alignItems: "center",
        justifyContent: "center", gap: 16,
        fontFamily: "'IBM Plex Sans','Helvetica Neue',sans-serif", fontSize: 13,
      }}>
        <div>{slow ? "Verificando tu sesión…" : "Loading…"}</div>
        {slow && (
          <div style={{ textAlign: "center", maxWidth: 320, lineHeight: 1.5 }}>
            <div style={{ color: DARK.textDim, marginBottom: 12 }}>
              Está tardando más de lo normal. Puede ser tu conexión o una versión
              antigua en caché.
            </div>
            <button
              type="button"
              data-testid="auth-gate-reload"
              onClick={() => window.location.reload()}
              style={{
                background: DARK.accent, color: "#000", border: "none",
                borderRadius: 6, padding: "8px 16px", fontSize: 13, cursor: "pointer",
              }}
            >
              Recargar
            </button>
          </div>
        )}
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  return children;
}
